// extracted by mini-css-extract-plugin
export default {"input":"Input_input__wH190","send":"Input_send__+Kv4n"};